import api from './api'
import authService from './authService'

export const normaService = {
  // ── Tipos de Norma Legal ───────────────────────────────────────────
  getTiposNormas(idTipoNl = null, buscar = null) {
    const rol = authService.getUserRol()
    const base = rol === 'PUBLIC' ? '/api/v1.0/spa/pub/tnl/' : '/api/v1.0/spa/tnl/'
    if (idTipoNl) {
      return api.get(`${base}?id=${idTipoNl}`)
    }
    const filters = buscar ? `&filters=${buscar}` : ''
    return api.get(`${base}?estado=H${filters}`)
  },

  // ── Unidades Organizativas ─────────────────────────────────────────
  getUO(idUo = null, buscar = null) {
    if (idUo) return api.get(`/api/v1.0/spa/uo/?id=${idUo}`)
    const filters = buscar ? `&filters=${buscar}` : ''
    return api.get(`/api/v1.0/spa/uo/?estado=H${filters}`)
  },

  // ── Voces de Norma Legal ───────────────────────────────────────────
  getVoces(idVoz = null, buscar = null, tipoCaracter = null) {
    const rol = authService.getUserRol()
    const base = rol === 'PUBLIC' ? '/api/v1.0/spa/pub/vnl/' : '/api/v1.0/spa/vnl/'
    if (idVoz) return api.get(`${base}?id=${idVoz}`)
    let params = '?estado=H'
    if (buscar) params += `&descripcion=${buscar}`
    if (tipoCaracter) params += `&tipo_caracter=${tipoCaracter}`
    return api.get(`${base}${params}`)
  },

  // ── Afectaciones de Norma Legal ────────────────────────────────────
  getAfectaciones(idAfectacion = null, buscar = null) {
    if (idAfectacion) return api.get(`/api/v1.0/spa/anl/?id=${idAfectacion}`)
    const filters = buscar ? `&filters=${buscar}` : ''
    return api.get(`/api/v1.0/spa/anl/?estado=H${filters}`)
  },

  // ── Oficinas ───────────────────────────────────────────────────────
  getOficinas(idOficina = null, rolAuth = null, buscar = null) {
    if (idOficina) return api.get(`/api/v1.0/spa/oficina/?id=${idOficina}`)
    let params = '?estado=H'

    const safeRolAuth = rolAuth ? encodeURIComponent(rolAuth) : ''
    const safeBuscar = buscar ? encodeURIComponent(buscar) : ''

    // Legacy Angular behavior: second arg was sent as `filters` when listing oficinas.
    if (safeBuscar) {
      params += `&filters=${safeBuscar}`
      if (safeRolAuth) params += `&rol_auth=${safeRolAuth}`
    } else if (safeRolAuth) {
      params += `&filters=${safeRolAuth}`
    }

    return api.get(`/api/v1.0/spa/oficina/${params}`)
  },

  // ── Tipos de Norma por Oficina ─────────────────────────────────────
  getTiposNormasPorOficina(idOficina) {
    return api.get(`/api/v1.0/spa/oficina_tnl/?id_oficina=${idOficina}`)
  },

  // ── Oficina Notif ──────────────────────────────────────────────────
  getOficinaNotif(idOficinaNotif = null, buscar = null) {
    if (idOficinaNotif) return api.get(`/api/v1.0/spa/oficina_notif/?id=${idOficinaNotif}`)
    const filters = buscar ? `&filters=${buscar}` : ''
    return api.get(`/api/v1.0/spa/oficina_notif/?estado=H${filters}`)
  },

  // ── Norma Legal (set/get de estado global para edición) ───────────
  _normaToUpdate: { id: '', id_tipo_nl: '', numero: '' },

  setNormaLegalToUpdate(id, idTipoNl, numero) {
    this._normaToUpdate = { id, id_tipo_nl: idTipoNl, numero }
  },

  getNormaLegalToUpdate() {
    return { ...this._normaToUpdate }
  },
}

export default normaService
